export default __webpack_public_path__ + "static/aeswibon-2fb4066dbd6c68de984e9f15ac2de441.jpg";